// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__j8TkJ","colMin":"styles_colMin__NxEZ4","colCheckbox":"styles_colCheckbox__1PEgS"};